import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UsuarioGateway } from "../../models/usuario/gateways/usuario.gateway";
import { UsuarioUltConexionModel } from "../../models/usuario/usuario-ult-conexion.model";
import { UsuarioRequestModel } from "../../models/usuario/usuario-request.model";


@Injectable(
    {
        providedIn: 'root'
    }
)
export class UsuarioUseCase {

    private nombre_ultima_conexion: string = "ultimaConexion";

    constructor(private gateway: UsuarioGateway) { }

    ultimaConexion(usuario: UsuarioRequestModel): Observable<UsuarioUltConexionModel> {
        return this.gateway.ultimaConexion(usuario);
    }

    //Guarda la ultima conexion en el Session Storage
    guardarUltimaConexionSessionStorage(data: UsuarioUltConexionModel): void {
        sessionStorage.setItem(this.nombre_ultima_conexion, JSON.stringify(data.ultima_conexion));
    }

    //Obtiene la ultima conexion en el Session Storage
    getUltimaConexionSessionStorage(): any {
        return JSON.parse(sessionStorage.getItem(this.nombre_ultima_conexion)!);
    }

    comprobarUltimaConexionSessionStorage(): boolean {
        return sessionStorage.getItem(this.nombre_ultima_conexion) === null ? false : true;
    }
}